module.exports = __webpack_public_path__ + "static/media/acams-brochure.7e4ae8ac.pdf";